export const REACT_GA_ENABLED = true;

export const SERIES_ZERO_CONTRACT_ADDRESS = '0x609054A45966B66D3b38f789350DF8E573ab2d8B'; // mainnet
// export const SERIES_ZERO_CONTRACT_ADDRESS = '0x2f9364E3bb5e9f4c7E38a202856Ed131930f4772'; // rinkeby

export const SUPPLY_DATA_API_ENDPOINT = "https://api.3q.club/serieszero/supplydata" // mainnet
// export const SUPPLY_DATA_API_ENDPOINT = "https://api-rinkeby.3q.club/serieszero/supplydata" // rinkeby